// src/app/modules/Members/index.jsx
import React, { Suspense } from "react";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { MembersMainPage } from "./main";

export function Spaces() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <MembersMainPage />
    </Suspense>
  );
}